import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import { connect } from "react-redux";

const styles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    marginTop: "150px",
    textAlign: "center"
  },
  image: {
    display: "inline-block",
    marginTop: "50px"
    // maxWidth: "100%",
    // width: "100%"
  }
});

function NotFound(props) {
  const { classes, isLogin } = props;
  useEffect(() => {
    if (!isLogin) {
      // console.log("go to signin");
      // window.location.replace("/");
      props.history.replace("/");
    }
    // eslint-disable-next-line
  }, []);
  // console.log("isLogin", isLogin);
  // console.log("props", props);
  return <div className={classes.root}>404 Not Found</div>;
}

NotFound.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  isLogin: state.user.isLogin
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(NotFound));
